import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { take } from 'rxjs';
import { AuthenticationGuard } from './core/authentication/authentication.guard';
import { GlobalSettingsService } from './core/service/global-settings.service';
import { UserListService } from './core/service/user-list.service';
import { BlankComponent } from './shared/layouts/blank/blank.component';
import { FullComponent } from './shared/layouts/full/full.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'i',
    pathMatch: 'full'
  },
  {
    path: 'i',
    component: FullComponent,
    children: [
      {
        path: '',
        canLoad: [() => inject(AuthenticationGuard).canActivate()],
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
      }
    ],
    resolve: {
      globalSettings: () =>
        inject(GlobalSettingsService).globalSettings$.pipe(take(1)),
      allUsers: () => inject(UserListService).users$.pipe(take(1))
    }
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '404',
        loadChildren: () =>
          import('./pages/not-found/not-found.module').then(
            (m) => m.NotFoundModule
          )
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/login/login.module').then((m) => m.LoginModule)
      },
      {
        path: 'logout',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./pages/reset-password/reset-password.module').then(
            (m) => m.ResetPasswordModule
          )
      },
      {
        path: 'change-email',
        loadChildren: () =>
          import('./pages/change-email/change-email.module').then(
            (m) => m.ChangeEmailModule
          )
      },
      {
        path: 'pin',
        loadChildren: () =>
          import('./pages/pin-code/pin-code.module').then(
            (m) => m.PinCodeModule
          )
      },
      {
        path: 'signup/user/:signupToken',
        loadChildren: () =>
          import('./pages/signup-user/signup-user.module').then(
            (m) => m.SignupUserModule
          )
      },
      {
        path: 'suggestion/:tenant',
        loadChildren: () =>
          import('./pages/suggestion-form/suggestion-form.module').then(
            (m) => m.SuggestionFormModule
          )
      },
      {
        path: 'custom-survey/:id',
        loadChildren: () =>
          import(
            './pages/custom-survey-respond/custom-survey-respond.module'
          ).then((m) => m.CustomSurveyRespondModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];
